
import { Component, Vue } from 'vue-property-decorator';
import * as SurveyVue from "survey-vue";  
import * as surveyEnv from "@/components/survey/survey-glossary";
import moment from 'moment-timezone';
import {applicationInfoType} from "@/types/Application"
import {MigrateStore} from './MigrateStore';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import "@/store/modules/common";
const commonState = namespace("Common");

@Component
export default class ApplicationStatus extends Vue {

    @commonState.State
    public userId!: string;

    @commonState.State
    public existingApplication!: Boolean;

    @commonState.State
    public locationsInfo!: any[];

    @commonState.Action
    public UpdateLocationsInfo!: (newLocationsInfo) => void

    @commonState.Action
    public UpdateExistingApplication!: (newExistingApplication) => void

    @applicationState.Action
    public UpdateUserId!: (newUserId) => void

    @applicationState.Action
    public UpdateCurrentApplication!: (newCurrentApplication) => void

    @applicationState.Action
    public UpdateLastUpdated!: (newLastUpdated) => void

    @applicationState.Action
    public UpdateApplicationId!: (newApplicationId) => void

    previousApplications = []
    previousApplicationFields = [
        { key: 'deceased_name',label: 'Application',     sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:20%;'},
        { key: 'lastUpdated', label: 'Last Updated',     sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:20%;'},
        { key: 'lastFiled',   label: 'Last Filed',       sortable:true,  tdClass: 'border-top', thStyle:'font-size:11pt; width:20%;'},
        { key: 'status',      label: 'Status',           sortable:true,  tdClass: 'border-top', thStyle:'font-size:10pt; width:15%;'},
        { key: 'packageNum',  label: 'Package#',         sortable:false, tdClass: 'border-top', thStyle:'font-size:10pt; width:15%;'},
        { key: 'edit',        label: '',                 sortable:false, tdClass: 'border-top', thStyle:'font-size:10pt; width:10%;'}
    ]
    confirmDelete = false;
    currentApplication = {} as applicationInfoType;
    applicationToDelete = {}
    indexToDelete = -1 
    applicationId = ''
    error = ''
    deleteErrorMsg = ''
    deleteErrorMsgDesc = ''
    deleteError = false ;
    windowHeight = 0;
    footerHeight = 0;
    headerHeight = 0; 
    buttonMenuHeight = 0;
    infoContentHeaderHeight = 0;
    dataLoaded = false;

    mounted() {
        window.addEventListener('resize', this.getWindowHeight);
        this.extractFilingLocations();
        this.getWindowHeight();
    }
    public preQualify() {
        this.$router.push({ name: "pre-qualification" });
    }

    public getWindowHeight() {
        this.windowHeight = document.documentElement.clientHeight;
        this.footerHeight = (document.getElementsByName("navigation-footer")[0] as HTMLElement)?.clientHeight;
        this.headerHeight = (document.getElementsByName("navigation-topbar")[0] as HTMLElement)?.clientHeight;
        this.buttonMenuHeight = (document.getElementsByName("button-menu")[0] as HTMLElement)?.clientHeight;
        this.infoContentHeaderHeight = (document.getElementsByName("info-content-header")[0] as HTMLElement)?.clientHeight;
    }

    get getHeight() {        
        return this.windowHeight-this.footerHeight-this.headerHeight-1 + 'px'
    }

    get getTableHeight() {        
        return this.windowHeight-this.footerHeight-this.headerHeight-this.buttonMenuHeight-this.infoContentHeaderHeight-10 + 'px'
    }

    public openTerms() {
        this.$router.push({name: "terms"})
    }

    public loadApplications () {
    //TODO: when extending to use throughout the province, the timezone should be changed accordingly
    //TODO: read in the data required to navigate to the eFilingHub package page
        this.dataLoaded = false;
        this.$http.get('/app-list/')
        .then((response) => {
            for (const appJson of response.data) {
                const app = {deceased_name: '', lastUpdated:0, lastUpdatedDate:'', id:0, app_type:'', lastFiled:0, lastFiledDate:''};
                app.lastUpdated = appJson.last_updated?moment(appJson.last_updated).tz("America/Vancouver").diff('2000-01-01','minutes'):0;
                app.lastUpdatedDate = appJson.last_updated?moment(appJson.last_updated).tz("America/Vancouver").format():'';                
                app.lastFiled = appJson.last_filed?moment(appJson.last_filed).tz("America/Vancouver").diff('2000-01-01','minutes'):0;
                app.lastFiledDate = appJson.last_filed?moment(appJson.last_filed).tz("America/Vancouver").format():'';                
                app.id = appJson.id;
                app.app_type = appJson.app_type;
                app.deceased_name = appJson.deceased_name;
                this.previousApplications.push(app);
            }

            this.dataLoaded = true;
            //console.log(this.previousApplications)       
        },(err) => {            
            //console.log(err)
            this.dataLoaded = true;
            this.error = err;        
        });
    }

    public extractFilingLocations() {
        this.$http.get('/efiling/locations/')
        .then((response) => {
            // console.log(Object.keys(response.data))
            const locationsInfo = response.data 
            const locationNames = Object.keys(response.data);
            const locations = []
            for (const location of locationNames){
                // console.log(location)
                // console.log(locationsInfo[location])
                const locationInfo = locationsInfo[location];
                const address = locationInfo.address_1?(locationInfo.address_1+ ', '):''  + 
                                locationInfo.address_2?(locationInfo.address_2 + ', '):'' + 
                                locationInfo.address_3?(locationInfo.address_3 + ', '):'';

                const postalCode = locationInfo.postal?? '';
                const city = locationInfo.city?? '';
                const province = locationInfo.province?? '';
                locations.push({
                    id: locationInfo.location_id, 
                    name: location, 
                    address: address.slice(0,-2),                    
                    city,
                    postalCode,
                    province,
                })
            }
            // console.log(locations)
            this.UpdateLocationsInfo(locations);
            this.loadApplications();
            // if(response.data.length>0) {
            //     this.navigate("returning");
            // }else{
            //     this.navigate("new");
            // }        
        
        },(err) => console.log(err));
        
    }

    public beginApplication() {
           
        this.$store.dispatch("Application/UpdateInit", Vue.filter('get-current-version')());
        this.UpdateUserId(this.userId);
        this.UpdateExistingApplication(false); 
        this.$router.push({name: "surveys" });        
    }

    public navigateToEFilingHub(packageNumber) {
        //TODO: replace input value with the eFilingHub link
        console.log("going to hub")
        //location.replace(packageNumber)
    }

    public resumeApplication(applicationId) {      
    
        this.$http.get('/app/'+ applicationId + '/')
        .then((response) => {
            const applicationData = response.data

            // console.log(applicationData)
            const storeMigrationFn = new MigrateStore() 
            this.currentApplication = storeMigrationFn.migrate(applicationData, Vue.filter('get-current-version')());   

            this.$router.push({name: "surveys" })        
        }, err => {
            //console.log(err)
            this.error = err;        
        });
    }   

    public removeApplication(application, index) {
        this.deleteErrorMsg = '';
        this.deleteErrorMsgDesc = '';
        this.deleteError = false;
        this.applicationToDelete = application;
        this.indexToDelete = index;
        this.confirmDelete=true;         
    }    

    public confirmRemoveApplication() {
        this.$http.delete('/app/'+ this.applicationToDelete['id'] + '/')
        .then((response) => {
            //console.log(response.data)
            
            var indexToDelete = this.previousApplications.findIndex((app) =>{if(app.id == this.applicationToDelete['id'])return true});
            if(indexToDelete>=0)this.previousApplications.splice(indexToDelete, 1);  
            
        },err => {
            const errMsg = err.response.data.error;
                    //console.log(err.response)
            this.deleteErrorMsg = errMsg.slice(0,60) + (errMsg.length>60?' ...':'');
            this.deleteErrorMsgDesc = errMsg;
            this.deleteError = true;            
        });
        this.confirmDelete=false;  
    }


    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);
    }
};
